import { render, staticRenderFns } from "./claimDtlInsure.vue?vue&type=template&id=0791d0fa&scoped=true&"
import script from "./claimDtlInsure.vue?vue&type=script&lang=js&"
export * from "./claimDtlInsure.vue?vue&type=script&lang=js&"
import style0 from "./claimDtlInsure.vue?vue&type=style&index=0&id=0791d0fa&prod&lang=scss&scoped=true&"
import style1 from "./claimDtlInsure.vue?vue&type=style&index=1&id=0791d0fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0791d0fa",
  null
  
)

export default component.exports